<div class="navbar-container flex items-center justify-between ps-2 pe-6">
    <ng-content select="[backlink]"></ng-content>
    <div class="hidden md:flex">
        <ng-container *ngFor="let anchor of anchors">
            <div
                (click)="anchorClick.emit(anchor)"
                class="navbar-anchor box-border cursor-pointer flex items-center ps-4 pe-4"
                [class.active]="anchor.id === activeAnchorId"
            >
                <span class="title title-lg">{{ anchor.title | translate }}</span>
                <span class="title title-sm">{{ anchor.titleSmall | translate }}</span>
            </div>
        </ng-container>
    </div>
    <ng-content select="[clipboard-button]"></ng-content>
</div>
